<div
  v-if="shouldRenderConfig"
  v-show="alwaysShow || getShowUpload"
  v-bind:class="[getClassName, getAttribute('statusUploaded') ? getClassName + 'Uploaded' : '', getAttribute('isLoading') ? getClassName + 'IsLoading' : '']"
>
  <appUploadDropzone :propsData="propsData"></appUploadDropzone>
  <div v-bind:class="getClassName + 'LoadingContainer'" v-show="getAttribute('isLoading')">
    <ProgressBar :value="getAttribute('loadingProgress')"  style="width:100%"></ProgressBar>
    <div v-bind:class="getClassName + 'LoadingValue'" >
      {{parseInt(getAttribute('loadingProgress')) + " %"}}
    </div>
  </div>
  <div v-bind:class="getClassName + 'Preview'" v-if="getAttribute('statusUploaded')">
    <appUploadPreview 
      :propsData="propsData" :useClassName="getClassName + 'PreviewContainer'"
      v-if="getShowPreviewInUpload && getAttribute('previewFile')">
    </appUploadPreview>
    <div v-bind:class="getClassName + 'StatusContainer'">
      <appUploadPreflight :propsData="propsData" :useClassName="getClassName + 'PreflightContainer'"></appUploadPreflight>
      <appUploadActions :propsData="propsData" :useClassName="getClassName + 'ActionsContainer'"></appUploadActions>
    </div>
  </div>
</div>
